import { ISettings } from './types';

import {
  DEFAULT_SETTING_COMMON,
  DEFAULT_SETTING_MAIN,
  DEFAULT_SETTINGS_EPISODE,
  DEFAULT_SETTINGS_LINKS,
  SETTINGS_VERSION,
  ISettingsColors,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';

const INITIAL_FONTS: ISettingsFonts = { main: {}, episode: {}, common: {} };
const INITIAL_COLORS: ISettingsColors = { main: {}, episode: {}, common: {} };

const DEFAULT_SETTING: ISettings = {
  settingsVersion: SETTINGS_VERSION,
  feedUrl: undefined,
  defaultFeedUrl: undefined,
  common: DEFAULT_SETTING_COMMON,
  main: DEFAULT_SETTING_MAIN,
  links: DEFAULT_SETTINGS_LINKS,
  episode: DEFAULT_SETTINGS_EPISODE,
  colors: INITIAL_COLORS,
  fonts: INITIAL_FONTS,
  events: {},
};

export { INITIAL_FONTS, INITIAL_COLORS, DEFAULT_SETTING };
